import { useEffect, useMemo, useState } from "react";
import menuItems from "./index";
import { filterByRole } from "../utils/common";

const useMenuItems = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const handler = () => {
      setRefreshKey((k) => k + 1);
    };

    window.addEventListener("menu-updated", handler);

    return () => {
      window.removeEventListener("menu-updated", handler);
    };
  }, []);

  const roleID = Number(localStorage.getItem("roleID") || 0);

  const items = useMemo(() => {
    return menuItems.items
      .map((item) => filterByRole(item, roleID))
      .filter(Boolean);
  }, [roleID, refreshKey]); 

  return { items };
};

export default useMenuItems;
